import { render } from "./PflegeList.vue?vue&type=template&id=c0551b5a"
import script from "./PflegeList.vue?vue&type=script&lang=js"
export * from "./PflegeList.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__